import(/* webpackMode: "eager" */ "/app/services/posa-website/src/app/global-error.tsx");
